import React from 'react';
import { Link } from 'react-router-dom';

type LinkButtonProps = {
  to: string;
  btnDescription: string;
};

const LinkButton: React.FC<LinkButtonProps> = ({ to, btnDescription }) => (
  <div className='w-11/12 md:w-full md:mt-6 md:flex md:justify-center'>
    <Link
      to={to}
      target="_blank"
      rel="noopener noreferrer"
      className="group flex items-center justify-center px-6 py-2 bg-white border border-halo-pink text-halo-pink hover:text-halo-pink text-md font-medium rounded-sm transition duration-300 hover:bg-halo-pink-bg hover:border-halo-pink-bg hover:underline"
    >
      {btnDescription}
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="ml-2 group-hover:stroke-current group-hover:text-halo-pink"
      >
        <path
          d="M2 8L14 8M10 4L14 8L10 12"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Link>
  </div>
);

export default LinkButton;
